"use client";
import React from "react";
export function assertContextExists(contextVal, msgOrCtx) {
    if (!contextVal) {
        throw typeof msgOrCtx === "string"
            ? new Error(msgOrCtx)
            : new Error(`${msgOrCtx.displayName} not found`);
    }
}
/**
 * Creates and returns a Context and two hooks that return the context value.
 * The Context type is derived from the type passed in by the user.
 * The first hook returned guarantees that the context exists so the returned value is always CtxValue
 * The second hook makes no guarantees, so the returned value can be CtxValue | undefined
 */
export const createContextAndHook = (displayName, options) => {
    const { assertCtxFn = assertContextExists } = options || {};
    const Ctx = React.createContext(undefined);
    Ctx.displayName = displayName;
    const useCtx = () => {
        const ctx = React.useContext(Ctx);
        assertCtxFn(ctx, `${displayName} not found`);
        return ctx;
    };
    const useCtxWithoutGuarantee = () => {
        const ctx = React.useContext(Ctx);
        return ctx ? ctx : {};
    };
    return [Ctx, useCtx, useCtxWithoutGuarantee];
};
//# sourceMappingURL=createContextAndHook.js.map